import React from "react";
import "./checkcross.css";

export default function RedCrossWithAnimation() {
  return (
    <div class="wrapper">
      <svg
        class="crossmark animateElement"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 52 52"
      >
        <circle
          class="crossmark__circle animateElement"
          cx="26"
          cy="26"
          r="25"
          fill="none"
        />
        <path
          class="cross__path cross__path--right animateElement"
          fill="none"
          d="M16,16 l20,20"
        />
        <path
          class="cross__path cross__path--left animateElement"
          fill="none"
          d="M16,36 l20,-20"
        />
      </svg>
    </div>
  );
}
